import { Box, Button, Text,useColorMode,useColorModeValue  } from '@chakra-ui/react'
import React from 'react'
import tripoto from '../Components/assets/Tripoto.png'
import { BsFillArrowUpRightSquareFill,BsGithub } from "react-icons/bs";
import Dsw from '../Components/assets/Dsw.png'
import mediaflow from '../Components/assets/mediaflow.png'
import shopkaro from '../Components/assets/shopkaro.png'
import lenskart from '../Components/assets/lenskart.png'

import {useEffect} from 'react'
import Aos from 'aos'
import "aos/dist/aos.css"

const Projects = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  useEffect(() => {
    Aos.init({duration:3000})
   
  }, [])



  return (
    <div id="projects" data-aos="zoom-out-right" style={{overflow:"hidden"}}>
<h1 style={{textAlign:"center",fontSize:"50px",marginTop:"40px",marginBottom:"30px"}}>Projects</h1>
<div className='container'>

  <Box className='box' marginTop={{base:"30px"}}>
    <span></span>
  <div class="project-card">
    <div className='content'>
      <h2 class="project-title">DSW Clone</h2>
      <img src={Dsw} alt="" />
      <p class="project-description">Dsw is E-commerce Website that deals with shoes and Accessories</p>
        <Text mt={"10px"}>Tech Stack : HTML | CSS | JavaScript | React | Chakra ui</Text>
      <a href="https://dsw-ecommerce-app-ten.vercel.app/"  class="project-deployed-link">

      <Button colorScheme='white' variant='ghost' border={"1px solid green"} mr={"10px"}>Deploy
      <BsFillArrowUpRightSquareFill />
      
      
      </Button>
      
      </a>
      <a href="https://github.com/uzairshaikh123/DSW" class="project-github-link">

     <Button colorScheme='white' variant='ghost' border={"1px solid green"}>Github
     <BsGithub />
     </Button>
      </a>
    </div>
  </div>
  </Box>
  <Box className='box'>
    <span></span>
   <div class="project-card">
    <div className='content'>
      <h2 class="project-title">Buffer Clone</h2>
      <img src={mediaflow} alt="" />
      <p class="project-description">Buffer.com is a social media management website that helps us to manage our social media accounts from one place</p>
        <Text mt={"10px"}>Tech Stack : HTML | CSS | JavaScript</Text>
      <a href="https://media-flow.netlify.app/"  class="project-deployed-link">


      <Button colorScheme='white' variant='ghost' border={"1px solid green"} mr={"10px"}>Deploy
      <BsFillArrowUpRightSquareFill />
      </Button>
      </a>
      <a href="https://github.com/fehmida99/Buffer.com-Clone" class="project-github-link">

     <Button colorScheme='white' variant='ghost' border={"1px solid green"}>Github
     <BsGithub />
     </Button>
      </a>

    </div>
   </div>
  </Box>

  <Box className='box'>
    <div class="project-card">
    <span></span>

    <div className='content' >
      <h2 class="project-title">Tripoto Clone</h2>
      <img width={"100%"} src={tripoto} alt="" />
      <p class="project-description">Tripoto is tour and hotels booking website that helps us to book the hotels ans plan our tour online</p>
        <Text mt={"10px"}>Tech Stack : HTML | CSS | JavaScript</Text>
      <a href="https://tripoto-clone-two.vercel.app/"  class="project-deployed-link">
     
     <Button colorScheme='white' variant='ghost' border={"1px solid green"} mr={"10px"}>Deploy 
      <BsFillArrowUpRightSquareFill />
     </Button>
      </a>

      <a href="https://github.com/uzairshaikh123/Tripoto" class="project-github-link">

     <Button colorScheme='white' variant='ghost' border={"1px solid green"}>Github
     <BsGithub />
     
     
     </Button>
      </a>
    </div>
  </div>
    </Box>
      <Box className='box'>
    <span></span>
   <div class="project-card">

    <div className='content'>
      <h2 class="project-title">Limeroad Clone</h2>
      <img src={shopkaro} alt="" />
      <p class="project-description">limeroad.com is a e-commerce site where we can buy wide range of clothes and Accessories</p>
     
        <Text mt={"10px"}>Tech Stack : HTML | CSS | JavaScript | React | Redux | Chakra ui </Text>
      <a href="https://shopkaro.vercel.app/"  class="project-deployed-link">

      <Button colorScheme='white' variant='ghost' border={"1px solid green"} mr={"10px"}>Deploy
      <BsFillArrowUpRightSquareFill />
      </Button>
      </a>
      <a href="https://github.com/uzairshaikh123/shopkaro-clone" class="project-github-link">

     <Button colorScheme='white' variant='ghost' border={"1px solid green"}>Github
     <BsGithub />
     </Button>
      </a>

    </div>
   </div>
  </Box>
      <Box className='box' marginTop={{base:"70px",sm:"40px",md:'0px',xl:'0px'}}>
    <span></span>
   <div class="project-card">

    <div className='content'>
      <h2 class="project-title">Lenskart Clone</h2>
      <img src={lenskart} alt="" />
      <p class="project-description">Lenskart is a e-commerce site of eyewares where we can buy wide range of lens and Sunglasses</p>
     
        <Text mt={"10px"}>Tech Stack : HTML | CSS | JavaScript | React | Redux | Chakra UI | Node.js | Express.js | MongoDB  </Text>
      <a href="https://eyekart-sachin-kesarwani.vercel.app/"  class="project-deployed-link">

      <Button colorScheme='white' variant='ghost' border={"1px solid green"} mr={"10px"}>Deploy
      <BsFillArrowUpRightSquareFill />
      </Button>
      </a>
      <a href="https://github.com/Sachin-Kesarwani/omniscient-dust-8885" class="project-github-link">

     <Button colorScheme='white' variant='ghost' border={"1px solid green"}>Github
     <BsGithub />
     </Button>
      </a>

    </div>
   </div>
  </Box>
</div>




    </div>
  )
}

export default Projects